import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import SignInFormComponent from "@/app/modules/auth/sign-in/SignInForm";
import Logo from "../../main/components/Logo";
import RegisterFormComponent from "./RegisterFormComponent";

export default function RegisterOrLoginModal({show, onHide, endLoginOrRegister}){
    const [step, setStep] = useState(1);

    return(
        <Modal
        title=""
        show={show}
        hideBottom={true}
        size="md"
        onHide={onHide}
        onSubmit={() => onHide()}>
            <div className="text-center py-3">
                <Logo/>
            </div>
            {step == 1 ? 
                <SignInFormComponent closeModal={() => endLoginOrRegister()} changeRegister={()=>setStep(step+1)}/>
                :
                <RegisterFormComponent closeModal={() => endLoginOrRegister()} changeLogin={()=>setStep(1)}/>
            }

      </Modal>
    )
}